import { render, staticRenderFns } from "./neoinfadi.vue?vue&type=template&id=bd30d3e6&scoped=true"
import script from "./neoinfadi.vue?vue&type=script&lang=js"
export * from "./neoinfadi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd30d3e6",
  null
  
)

export default component.exports